<mat-form-field class="deltaker-navn">
  <input matInput [formControl]="skjema().controls.navn" [placeholder]="'Navn'|translate" data-testid="navn-felt">
  @if (skjema().controls.navn.hasError('maxlength')) {
    <mat-error data-testid="maxlength">{{ skjema().controls.navn.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
  }
  @if (skjema().controls.navn.hasError(valideringsfeil.duplikat_navn)) {
    <mat-error data-testid="duplikat_navn">{{ 'Navn må være unikt'|translate }}</mat-error>
  }
</mat-form-field>

<mat-form-field class="deltaker-rolle">
  <input matInput [formControl]="skjema().controls.rolle" [placeholder]="'Rolle'|translate" data-testid="rolle-felt">
  @if (skjema().controls.rolle.hasError('maxlength')) {
    <mat-error data-testid="maxlength">{{ skjema().controls.rolle.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
  }
</mat-form-field>

<mat-form-field class="deltaker-kommentar">
  <input matInput [formControl]="skjema().controls.kommentar" [placeholder]="'Kommentar'|translate" data-testid="kommentar-felt">
  @if (skjema().controls.kommentar.hasError('maxlength')) {
    <mat-error data-testid="maxlength">{{ skjema().controls.kommentar.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
  }
</mat-form-field>

<mat-slide-toggle [formControl]="skjema().controls.skalSignere" class="deltaker-skal-signere" data-testid="skal-signere-felt">
  {{ 'Vis signaturfelt'|translate }}
</mat-slide-toggle>

<span class="deltaker-slett">
  <button mat-icon-button type="button" (click)="slett()" data-testid="slett-knapp">
    <mat-icon>delete</mat-icon>
  </button>
</span>
